import React from 'react';
import PropTypes from 'prop-types';
import ApplicationRoutes from '../../helpers/ApplicationRoutes';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';

const LinkToDate = ({ start, end, organizationId, disabled }) => {
    const path = ApplicationRoutes.organizationReportQuery.getPath({
        start,
        end,
        organizationId,
    });
    return (
        <Tooltip title="Create report">
            <Button
                component={Link}
                to={path}
                disabled={disabled}
                variant="contained"
                color="primary"
            >
                REPORT
            </Button>
        </Tooltip>
    );
};

LinkToDate.propTypes = {
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    organizationId: PropTypes.number.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default LinkToDate;



// WEBPACK FOOTER //
// ./src/components/report/LinkToDate.js